import React, { useState } from "react";

import { makeStyles } from "tss-react/mui";
import { Grid, Tab, Typography } from "@mui/material";

import WhitelabelLogo from "components/admin/WhitelabelLogo";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ButtonLink } from "components/MUIExtensions/ButtonLink";
import { LOGIN } from "routers/routePaths";

const useStyles = makeStyles()((theme) => ({
  outer: {
    background:
      "linear-gradient(180deg, rgba(227, 187, 92, 0.2) 0%, rgba(224, 255, 225, 0.2) 100%)",
    flex: 1,
    padding: theme.spacing(4, 0, 8, 0),
    gridColumn: "span 1",
    gridRow: "1 / span 3",
  },
  panel: {
    flex: 1,
  },
  tabList: {
    ".MuiTabs-flexContainer": {
      borderColor: "transparent",
      "&>:first-child": {
        marginRight: theme.spacing(1),
      },
    },
    ".MuiTab-root": {
      border: "inherit",
      borderColor: theme.palette.secondary.light,

      "&.Mui-selected": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  imgPos: {
    width: "100vw",
    maxWidth: "600px",
    position: "absolute",
    bottom: 0,
    left: "auto",
    right: "auto",
    marginLeft: theme.spacing(-3),
    zIndex: -1,
  },
}));

export const Landing = () => {
  const { classes } = useStyles();
  const [viewPos, setViewPos] = useState<"first" | "second">("first");

  const handleChange = (event, value) => {
    setViewPos(value);
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      className={classes.outer}
    >
      <TabContext value={viewPos}>
        <TabList className={classes.tabList} onChange={handleChange}>
          <Tab value="first" />
          <Tab value="second" />
        </TabList>
        <Grid sx={{ p: 5 }}>
          <WhitelabelLogo />
        </Grid>

        <TabPanel className={classes.panel} value="first">
          <Typography
            align="center"
            color="secondary"
            variant="h1"
            component="p"
          >
            Sua plataforma de economia e descarbonização energética
          </Typography>
          <img
            src="/static/img/Casal-com-app.png"
            alt="foto de um casal sorridente segurando um telefone com o aplicativo da enermatch"
            className={classes.imgPos}
          />
        </TabPanel>
        <TabPanel className={classes.panel} value="second">
          <Typography
            align="center"
            color="secondary"
            variant="h1"
            component="p"
          >
            Educando para a transição energética
          </Typography>
          <img
            src="/static/img/Aluno-com-app.png"
            alt="foto de uma criança sorridente apontando para um telefone com o aplicativo da enermatch"
            className={classes.imgPos}
          />
        </TabPanel>
      </TabContext>

      <ButtonLink variant="contained" sx={{ width: "70%" }} to={LOGIN}>
        Começar
      </ButtonLink>
    </Grid>
  );
};
